import { Navigate, Outlet, useParams } from "react-router-dom";
import { isValidUUID } from "../utils";

const RouteValidator = ({ isPatient }: { isPatient?: boolean }) => {
  let singleId: string | undefined = "";
  const { patientId } = useParams<{ patientId: string }>(); // Get the office id from the URL
  const { id } = useParams<{ id: string }>(); // Get the office id from the URL
  if (isPatient) {
    singleId = patientId;
  } else {
    singleId = id;
  }

  // If the id is invalid, redirect to 404
  if (singleId && !isValidUUID(singleId as string)) {
    return <Navigate to="/404" />;
  }

  // If id is valid, render the children routes
  return <Outlet />;
};

export default RouteValidator;
